const CORPORATE_GROUPS_URL = process.env.API_URL + '/corporate-group';

const getGroups = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(CORPORATE_GROUPS_URL)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const createGroup = (context, body) => {
  return new Promise((resolve, reject) => {
    context.$http.post(CORPORATE_GROUPS_URL, body)
      .then((response) => {
        resolve(response);
      }, error => {
        reject(error);
      });
  });
};

const updateGroup = (context, id, body) => {
  return new Promise((resolve, reject) => {
    context.$http.put(CORPORATE_GROUPS_URL + '/' + id, body)
      .then((response) => {
        resolve(response);
      }, error => {
        reject(error);
      });
  });
};

const deleteGroup = (context, id) => {
  return new Promise((resolve, reject) => {
    context.$http.delete(CORPORATE_GROUPS_URL + '/' + id)
      .then((response) => {
        resolve(response);
      }, error => {
        reject(error);
      });
  });
};

export default {
  getGroups,
  createGroup,
  updateGroup,
  deleteGroup
};



// WEBPACK FOOTER //
// ./src/brand/health/api/corporateGroups/index.js